module.exports = __webpack_public_path__ + "static/media/img7.9b658c00.jpg";